// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, Timestamp as tStamp} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from 'firebase/storage';
// import { getStorage } from "firebase/storage";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA5AC_OyqgoReZeSifFuC36r6SmeMKQMi4",
  authDomain: "loyaltea-46e52.firebaseapp.com",
  projectId: "loyaltea-46e52",
  storageBucket: "loyaltea-46e52.firebasestorage.app",
  messagingSenderId: "528134035046",
  appId: "1:528134035046:web:cb9ad4186d85521dad7fa7",
  measurementId: "G-LNK327BKNJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const Timestamp = tStamp;
// export const storage = getStorage(app);
// const analytics = getAnalytics(app);